/**
 * Resolve after the browser has had a chance to paint the current frame.
 *
 * INP measures a tap until the NEXT PAINT. A submit handler that sets its
 * loading state and then runs validation, analytics and request setup in the
 * same task (an `async` function only yields at a real await) holds that paint
 * hostage: field RUM on / showed the kundali submit button at ~300 ms with
 * most of it after the handler (2026-10-29). Awaiting this right after the
 * visible state change lets the spinner paint first; the rest runs in the
 * following task, unchanged and in the same order.
 *
 * requestAnimationFrame + setTimeout is the "after next paint" idiom. The
 * timeout fallback keeps a hidden tab (rAF paused) or a non-browser runtime
 * from stalling the caller.
 * @internal
 */
export const AFTER_NEXT_PAINT_FALLBACK_MS = 100;

export function afterNextPaint(): Promise<void> {
  return new Promise((resolve) => {
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      resolve();
    };
    const fallback = setTimeout(finish, AFTER_NEXT_PAINT_FALLBACK_MS);
    if (typeof requestAnimationFrame !== "function") return;
    requestAnimationFrame(() => {
      setTimeout(() => {
        clearTimeout(fallback);
        finish();
      }, 0);
    });
  });
}
